<template>
  <!-- <table
    striped
    class="table tablesorter table-striped table-sm"
    :class="tableClass"
    id="dtHorizontalVerticalExample"
    responsive
    ref="tableHorizantalScroll"
    cellspacing="0"
    width="100%"
  >
    <thead :class="theadClasses">
      <tr>
        <slot name="columns" :columns="columns">
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </slot>
      </tr>
    </thead>
    <tbody :class="tbodyClasses">
      <tr v-for="(item, index) in data" :key="index" :style="getStyle(item)">
        <slot :row="item" :index="index">
          <td v-for="(column, index) in colsWithValue(item)" :key="index">
            {{ itemValue(item, column) }}
          </td>
        </slot>
      </tr>
    </tbody>
  </table> -->
  <mdb-tbl
    responsive
    striped
    scrollX
    fixed
    maxWidth="600px"
    class="table-custom"
    cellspacing="0"
    width="100%"
  >
    <mdb-tbl-head>
      <tr>
        <slot name="columns" :columns="columns">
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </slot>
      </tr>
    </mdb-tbl-head>

    <mdb-tbl-body>
      <tr v-for="(item, index) in data" :key="index" :style="getStyle(item)">
        <slot :row="item" :index="index">
          <td v-for="(column, index) in colsWithValue(item)" :key="index">
            {{ itemValue(item, column) }}
          </td>
        </slot>
      </tr>
    </mdb-tbl-body>
  </mdb-tbl>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from "mdbvue";
export default {
  name: "base-table",
  components: {
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
      description: "Table columns",
    },
    data: {
      type: Array,
      default: () => [],
      description: "Table data",
    },
    type: {
      type: String, // striped | hover
      default: "",
      description: "Whether table is striped or hover type",
    },
    theadClasses: {
      type: String,
      default: "",
      description: "<thead> css classes",
    },
    tbodyClasses: {
      type: String,
      default: "",
      description: "<tbody> css classes",
    },
  },
  computed: {
    tableData() {
      return { columns: this.columns, rows: this.data };
    },
    tableClass() {
      return this.type && `table-${this.type}`;
    },
    colsWithValue() {
      return (row) => {
        return this.columns.filter((column) => this.hasValue(row, column));
      };
    },
  },
  methods: {
    getStyle(item) {
      if (!item) return {};
      if (Object.keys(item).includes("canceled")) {
        if (item.canceled == 1)
          return { "background-color": "#fc5c65", color: "#fff" };
        if (item.paid == 1)
          return { "background-color": "#26de81", color: "#fff" };
        if (item.purchased == 1 && item.canceled != 1 && item.paid != 1)
          return { "background-color": "#fd9644", color: "#fff" };
        if (item.delivered == 1)
          return { "background-color": "#fd6c9e", color: "#fff" };
          if (item.topay == 1)
          return { "background-color": "#BDB76B", color: "#fff" };
      }
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
  },
  mounted() {
    // console.log(window.$("#dtHorizontalVerticalExample"))
    // window.$("#dtHorizontalVerticalExample").DataTable({
    //   scrollX: true,
    // });
  },
};
</script>
<style lang="scss">
.table-custom {
  display: flex !important;
  overflow-x: scroll !important;
}
// .dtHorizontalVerticalExampleWrapper {
//   max-width: 600px;
//   margin: 0 auto;
// }
// #dtHorizontalVerticalExample th,
// td {
//   white-space: nowrap;
// }
// table.dataTable thead .sorting:after,
// table.dataTable thead .sorting:before,
// table.dataTable thead .sorting_asc:after,
// table.dataTable thead .sorting_asc:before,
// table.dataTable thead .sorting_asc_disabled:after,
// table.dataTable thead .sorting_asc_disabled:before,
// table.dataTable thead .sorting_desc:after,
// table.dataTable thead .sorting_desc:before,
// table.dataTable thead .sorting_desc_disabled:after,
// table.dataTable thead .sorting_desc_disabled:before {
//   bottom: 0.5em;
// }
</style>
